document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 768) {
        var buttonContainer = document.querySelector(".section-know-us-container");
        var logosContainer = document.querySelector(".section-know-us-block__logos");

        if (buttonContainer && logosContainer) {
            logosContainer.after(buttonContainer);
        }
    }
});
